<template>
  <div>
    <please-wait-modal/>
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
      <h1 class="h3 mb-0 text-gray-800">{{ this.$route.query.id != null ? 'Edit' : 'Add' }} Article</h1>
    </div>
    <div class="row">
      <div class="col-12 col-md-4 d-none d-md-block">
        <ul class="list-group">
          <li class="list-group-item p-5">
            <div class="ratio_169" :style="{'backgroundImage':'url('+picture+')'}" style="background-repeat: no-repeat; background-size: contain;"></div>
            <input type="file" name="photo" accept="image/*" class="d-none" id="file_input" @change="display_image">
            <a name="uploadPhoto" id="uploadPhoto" class="btn btn-outline-primary mt-4 btn-block btn-sm" href="#!" role="button" onclick="$('#file_input').trigger('click')">Upload Photo</a>
          </li>
        </ul>
      </div>
      <div class="col-12 col-md-8">
        <publish-web
          :data_media_type="media_type"
          :data_is_publish="is_publish"
          @on-media-type-changed="change_media_type"
          @on-publish-status-changed="change_publish_status"/>
        <div class="form-group">
          <div class="row px-3">
            <label for="#form-name" class="col-lg-4 pl-0 m-0 d-flex align-items-center">Title</label>
            <input class="form-control col-lg-8" id="form-name" v-model="title"/>
          </div>
        </div>
        <div class="form-group">
          <div class="row px-3">
            <label for="#form-name" class="col-lg-4 pl-0 m-0 d-flex align-items-center">Content</label>
            <textarea class="form-control col-lg-8" id="content-textarea" v-model="content"></textarea>
          </div>
        </div>
        <div class="form-group text-right">
          <a type="button" class="btn btn-danger" href="/article">Cancel</a>
          <button type="button" class="btn btn-primary" @click="save">Save</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'summernote/dist/summernote.css'
import summernote from 'summernote'

import please_wait_modal from '@/layout/please_wait_modal'
import publish_web from '@/layout/publish_web'
import modal_edit from '@/pages/master/helper_sub_category/modal_edit_sub_sub_category'

export default {
  components:{
    'please-wait-modal': please_wait_modal,
    'publish-web': publish_web,
    'modal-edit': modal_edit,
  },
  data(){
    return{
      picture: '',
      is_change_photo: true,
      title: '',
      content: '',
      media_type: '',
      is_publish: '',
    }
  },
  async mounted(){
    var context = this
    $('#content-textarea').summernote({
			height: '250',
			width: '100%',
			callbacks: {
				onChange: function(contents, $editable) {
					context.content = contents
				}
			},
			popover: {
				image: [],
				link: [],
				air: []
			},
			toolbar: [
				['style', ['bold', 'italic', 'underline', 'clear']],
				['font', ['strikethrough', 'superscript', 'subscript']],
				['fontsize', ['fontsize']],
				['color', ['color']],
				['para', ['ul', 'ol', 'paragraph']],
			]
    })
    
    if(this.$route.query.id != null){
      await this.get_data()
    }
  },
  methods:{
    change_media_type(val){
      this.media_type = val
    },
    change_publish_status(val){
      this.is_publish = val
    },
    async save(){
      try{
        if(this.title === '')
          this.$toasted.show('Title is empty')
        else if(this.content === '')
          this.$toasted.show('Content is empty')
        else if(this.is_publish === '')
          this.$toasted.show('Publish status is empty')
        else if(this.is_publish === 1 && this.media_type === '')
          this.$toasted.show('Publish media is empty')
        else{
          $('#please_wait_modal').modal('show')
          var data = {}
          if(this.$route.query.id != null)
            data.id = this.$route.query.id
          if(this.is_change_photo)
            data.image = {
              original_rotation: 0,
              image: await image2base64(this.picture)
            }
          data.title = this.title
          data.content = this.content
          data.total = this.total
          data.media_type = this.media_type
          data.is_publish = this.is_publish
          

          if(this.$route.query.id == null)
            var response = await axios.post(base_url+'/article',data)
          else
            var response = await axios.put(base_url+'/article',data)

          $('#please_wait_modal').modal('hide')
          var response_data = response.data
          if(response_data.status == "success"){
            location.href = '/article'
          }
          else
            this.$toasted.show(response_data.message)
        }
      } catch(e){
        $('#please_wait_modal').modal('hide')
        this.$toasted.show(e)
      }
    },
    async get_data(){
      try{
        var response = await axios.get(base_url+'/article?id='+this.$route.query.id)

        var response_data = response.data
        if(response_data.status == "success"){
          this.title = response_data.data.title
          this.content = response_data.data.content
          this.picture = base_url+'/images/article?file_name='+response_data.data.file_name
          this.is_change_photo = false
          this.media_type = response_data.data.media_type
          this.is_publish = response_data.data.is_publish
          $('#content-textarea').summernote("code", this.content)
        }
      } catch(e) {
        this.$toasted.show(e)
      }
    },
    display_image(event){
      // console.log(event.target.files[0].size)
      if(event.target.files[0].size > 1024 * 1024 * 5)
        this.$toasted.show('Your file size exceed 5 MB')
      this.picture = URL.createObjectURL(event.target.files[0])
      this.data_photo = event.target.files[0]
      this.is_change_photo = true
    },
  }
}
</script>
